export default "/build/images/map-marker-alert-major-icon.5d23cce4.png";